import { AxfoodProductDetailsViewModel, ComponentWsDTO, ComponentV2, RequestParams } from '@occ/api-client';

const componentApi = new ComponentV2({ baseUrl: '' });

export const getNavigationData = (componentId: string, pageLabel: string) =>
  componentApi.getNavigationDataV2(componentId, { pageLabel });

export const getItemsForYear = (yearUid: string) => componentApi.getNewsItemsForYearV2(yearUid);

export interface ProductAndQuantity extends AxfoodProductDetailsViewModel {
  quantity: number;
}

export interface BuyAllProductsWsDTO {
  title: string;
  products: ProductAndQuantity[];
  gridPackages?: {
    component?: ComponentWsDTO;
  };
}

export const getProductsForBuyAllBanner = async (componentId: string) => {
  const response = await componentApi.getProductsForBuyAllBannerV2(componentId);
  return response.data as BuyAllProductsWsDTO;
};

/**
 * CloudFront-only cache-key params for the packages endpoint (B2C-36081).
 * storeState is required whenever a session store exists (all users).
 * customerState=anonymous is sent only for anonymous sessions so non-public
 * (Small/Medium) bodies keep today's anonymous-only edge gate; ImageGrid
 * bodies are cached for all users when Hybris emits Cache-Control: public.
 */
export type ProductBannerPackagesEdgeCacheParams = {
  customerState?: 'anonymous';
  storeState: string;
};

export const getProductBannerPackages = async (
  componentId: string,
  edgeCacheParams?: ProductBannerPackagesEdgeCacheParams
) => {
  // The generated client types the second argument as RequestParams, which omits
  // `query`, but it spreads the argument straight into request(), which reads it.
  const response = await componentApi.getPackagesForProductBannerV2(componentId, {
    query: edgeCacheParams,
  } as RequestParams);
  return response.data;
};

/** CloudFront-only cache-key params (GG-4409). Not read by Hybris; stripped at origin by CF. */
export type ProductBannerEdgeCacheParams = {
  customerState: string;
  storeState: string;
  slotState: 'empty' | 'not-empty';
  cartState: 'empty' | 'not-empty';
  cartFilter: 'true' | 'false';
};

export const getProductBannerComponent = async (
  componentId: string,
  page?: string,
  size?: string,
  promotionStoreUid?: string,
  q?: string,
  sort?: string,
  edgeCacheParams?: ProductBannerEdgeCacheParams
) => {
  const response = await componentApi.getProductsForProductBannerV2(componentId, {
    page,
    size,
    promotionStoreUid,
    q,
    sort,
    ...edgeCacheParams,
  } as Record<string, string | undefined>);
  return response.data;
};

export const getCategoryNavigationTree = async ({ storeId }: { storeId: string }) => {
  const { data } = await componentApi.getCategoryNavigationTreeV2({ storeId, deviceType: 'OTHER' });
  return data as unknown as AccordionNavNodeType;
};
